export default __webpack_public_path__ + "files/code_themes/8ddf98d2dc9c387ff4a392bc3ae9642c.css";